import { render, staticRenderFns } from "./LpLayout.vue?vue&type=template&id=985f1c2c&"
import script from "./LpLayout.vue?vue&type=script&lang=js&"
export * from "./LpLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports